import { Carousel } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { routingConstants } from "@/Constants/routingConstants";

/**
 * Generate CandidateProfileCalenderPopups with the given data.

 */
export const CandidateProfileCalenderPopups = ({ data }) => {
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const { candidateDetails, candidateShiftScheduleFilter } = useSelector(
    (state) => state.clientCandidateDetail,
  );

  // Filter booked shifts
  const bookedShifts = data.filter(
    (item) =>
      item.contract_status === "Booked" &&
      candidateShiftScheduleFilter.shift_status !== "Applied" &&
      candidateShiftScheduleFilter.shift_status !== "Available",
  );

  // If no booked shifts, return null to prevent rendering an empty popover
  if (bookedShifts.length === 0) {
    return null;
  }

  return (
    <div className="CandidateShiftCalendarPopups_Wrapper min-h-[53px] !w-[220px] pb-2">
      <Carousel autoplay dots={false} autoplaySpeed={2000}>
        {bookedShifts.map((item, index) => {
          const { contract_id, contract_ref_no, start_time, end_time } = item;

          return (
            <div className="overflow-hidden font-openSans" key={index}>
              <div className="max-w-full px-[12px] py-[8px]">
                <div className="flex flex-col gap-[3px]">
                  <h4 className="m-0 text-[14px] font-semibold leading-[20px] text-black">
                    {candidateDetails?.role_name}
                  </h4>
                  {!clientUserAllPermissions ||
                  clientUserAllPermissions.is_allow_to_view_contract_detail ===
                    1 ? (
                    <Link
                      to={routingConstants.contractDetail(contract_id)}
                      className="text-[12px] font-medium leading-[normal] text-txtColor"
                    >
                      {contract_ref_no}
                    </Link>
                  ) : (
                    <span className="cursor-default text-[12px] font-medium leading-[normal] text-txtColor">
                      {contract_ref_no}
                    </span>
                  )}
                  <span className="text-[12px] font-medium leading-[normal] text-txtColor">
                    {moment(start_time, "HH:mm:ss").format("h:mm")} -{" "}
                    {moment(end_time, "HH:mm:ss").format("HH:mm")}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};
